/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAgentRunRequest = {
  agentId: string;
  runId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetAgentRunRequest$inboundSchema: z.ZodType<
  GetAgentRunRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  run_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "run_id": "runId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetAgentRunRequest$Outbound = {
  agent_id: string;
  run_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetAgentRunRequest$outboundSchema: z.ZodType<
  GetAgentRunRequest$Outbound,
  z.ZodTypeDef,
  GetAgentRunRequest
> = z.object({
  agentId: z.string(),
  runId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    runId: "run_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getAgentRunRequestToJSON(
  getAgentRunRequest: GetAgentRunRequest,
): string {
  return JSON.stringify(
    GetAgentRunRequest$outboundSchema.parse(getAgentRunRequest),
  );
}
export function getAgentRunRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAgentRunRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAgentRunRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAgentRunRequest' from JSON`,
  );
}
